import { useEffect } from 'react';

// Scroll progress bar — scales the referenced element from 0 to 1 across the page.
export const useScrollProgress = (ref) => {
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;

    let rafId = null;
    const update = () => {
      rafId = null;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = docHeight > 0 ? window.scrollY / docHeight : 0;
      el.style.transform = `scaleX(${progress})`;
    };
    const onScroll = () => {
      if (rafId === null) rafId = requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      if (rafId !== null) cancelAnimationFrame(rafId);
    };
  }, [ref]);
};
